module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "shadows-in-the-cave"
    }
  }, [_c('h1', [_vm._v("Shadows in the Cave")]), _vm._v(" "), _c('p', [_vm._v("Thou speakest yet to me!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Oh, Holy Fire in the Cave,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Thy tongues of gold and blue consume thy substance,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("As I, poor creature of an unknowing destiny,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Consume the life I barely knew.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Pretence and folly marks me sorely so")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Whilst shadows cast upon the Cave’s rough hue,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Holds me transfixed so like the Pole Star, true.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Tongues of flame in dreamlike state")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("That jump and dance and shadows make")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Enacted as a puppet tugged would go!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("But is thy shadow Chance or Fate,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Or do I for my pity’s sake,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Pretend to make a show?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Dross!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Am I so cheaply sold or bought,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Or destiny’s plaything, overwrought? CED.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24bd2ab4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 90
// module chunks = 0